import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../components/Common/Sidebar";
import TopBar from "../components/Common/TopBar";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  User,
  RotateCcw,
  FileText,
  Code,
  Package,
  Languages,
  AudioLines,
  Volume2,
  Mic,
  ArrowRightLeft,
} from "lucide-react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import Overview from "../components/UserDashboard/Overview";
import Profile from "../components/UserDashboard/Profile";
import PurchaseHistory from "../components/UserDashboard/PurchaseHistory";
import Support from "../components/UserDashboard/Support";
import DeveloperTools from "../components/UserDashboard/DeveloperTools/DeveloperTools";
import UpgradePlan from "../components/UserDashboard/UpgradePlan";
import Translation from "../components/UserDashboard/Translation";
import WebsiteTranslation from "../components/UserDashboard/WebsiteTranslation";
import CongratulationsModal from "../components/Modals/CongratulationsModal";
import ProtectedRoute from "../components/Common/ProtectedRoute";
import {
  TextToSpeech,
  SpeechToText,
  SpeechTranslations,
  TextToSpeechTranslation,
  SpeechToTextTranslation,
} from "../components/UserDashboard/SpeechStudio/index";

export const UserRoutes = () => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false); // Unified state for sidebar/drawer
  const [isMobile, setIsMobile] = useState(false);
  const [activeMenu, setActiveMenu] = useState("overview");
  const [showWelcomeModal, setShowWelcomeModal] = useState(
    location.state?.showWelcomeModal
  );

  const handleCloseWelcomeModal = () => {
    setShowWelcomeModal(false);
    // Clear the navigation state to prevent modal from reappearing on reload
    navigate(location.pathname, { replace: true, state: { ...location.state, showWelcomeModal: false } });
  };

  console.log("showWelcomeModal", showWelcomeModal);
  console.log("location.state", location.state);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth < 768;
      setIsMobile(isMobileDevice);
      // On mobile, drawer should be closed by default; on desktop, sidebar should be open
      setIsOpen(!isMobileDevice);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Update active menu based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path === "/user-dashboard" || path === "/user-dashboard/") {
      setActiveMenu("overview");
    } else if (path.includes("/profile")) {
      setActiveMenu("profile");
    } else if (path.includes("/purchase-history")) {
      setActiveMenu("purchase-history");
    } else if (path.includes("/upgrade-plan")) {
      setActiveMenu("subscription-plan");
    } else if (path.includes("/support")) {
      setActiveMenu("support");
    } else if (path.includes("/developer-tools")) {
      setActiveMenu("developer-tools");
    } else if (path.includes("/translation")) {
      setActiveMenu("translation");
    } else if (path.includes("/website-translation")) {
      setActiveMenu("website-translation");
    } else if (path.includes("/speech-studio/text-to-speech-translation")) {
      setActiveMenu("text-to-speech-translation");
    } else if (path.includes("/speech-studio/speech-to-text-translation")) {
      setActiveMenu("speech-to-text-translation");
    } else if (path.includes("/speech-studio/text-to-speech")) {
      setActiveMenu("speech-tts");
    } else if (path.includes("/speech-studio/speech-to-text")) {
      setActiveMenu("speech-stt");
    } else if (path.includes("/speech-studio/speech-translations")) {
      setActiveMenu("speech-translations");
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  const UserNavData = [
    {
      icon: <Grid className="h-6 w-6 mr-3" />,
      label: "Home",
      navigate: "/user-dashboard",
      id: "overview",
    },
    {
      icon: <User className="h-6 w-6 mr-3" />,
      label: "Profile",
      navigate: "/user-dashboard/profile",
      id: "profile",
    },
    {
      icon: <RotateCcw className="h-6 w-6 mr-3" />,
      label: "Purchase History",
      navigate: "/user-dashboard/purchase-history",
      id: "purchase-history",
    },
    {
      icon: <Package className="h-6 w-6 mr-3" />,
      label: "Subscription Plan",
      navigate: "/user-dashboard/upgrade-plan",
      id: "subscription-plan",
    },
    {
      icon: <FileText className="h-6 w-6 mr-3" />,
      label: "Support",
      navigate: "/user-dashboard/support",
      id: "support",
    },
    {
      icon: <Code className="h-6 w-6 mr-3" />,
      label: "Developer Tools",
      navigate: "/user-dashboard/developer-tools",
      id: "developer-tools",
    },
    {
      icon: <Languages className="h-6 w-6 mr-3" />,
      label: "NKENNEAi Translate",
      navigate: "/user-dashboard/translation",
      id: "translation",
    },
    // {
    //   icon: <Globe className="h-6 w-6 mr-3" />,
    //   label: "Website Translator",
    //   navigate: "/user-dashboard/website-translation",
    //   id: "website-translation",
    // },
    // ── Speech Studio group ──────────────────────────────────────────────────
    {
      icon: <AudioLines className="h-6 w-6 mr-3" />,
      label: "Speech Studio",
      badge: "Beta",
      id: "speech-studio",
      children: [
        {
          icon: <Volume2 className="h-4 w-4 mr-2" />,
          label: "Text-to-Speech",
          navigate: "/user-dashboard/speech-studio/text-to-speech",
          id: "speech-tts",
        },
        {
          icon: <Mic className="h-4 w-4 mr-2" />,
          label: "Speech-to-Text",
          navigate: "/user-dashboard/speech-studio/speech-to-text",
          id: "speech-stt",
        },
        {
          icon: <ArrowRightLeft className="h-4 w-4 mr-2" />,
          label: "Speech Translations",
          navigate: "/user-dashboard/speech-studio/speech-translations",
          id: "speech-translations",
        },
        // {
        //   icon: <Volume2 className="h-4 w-4 mr-2" />,
        //   label: "Text-to-Speech Translation",
        //   navigate: "/user-dashboard/speech-studio/text-to-speech-translation",
        //   id: "text-to-speech-translation",
        // },
        // {
        //   icon: <Mic className="h-4 w-4 mr-2" />,
        //   label: "Speech-to-Text Translation",
        //   navigate: "/user-dashboard/speech-studio/speech-to-text-translation",
        //   id: "speech-to-text-translation",
        // },
      ],
    },
  ];

  // Get current page info based on active menu
  const getCurrentPageInfo = () => {
    if (activeMenu === "overview") {
      return { title: null, badge: null }; // Show welcome message on home page
    }
    // Check top-level items
    for (const item of UserNavData) {
      if (item.id === activeMenu) return { title: item.label, badge: item.badge };
      if (item.children) {
        const child = item.children.find((c) => c.id === activeMenu);
        if (child) return { title: child.label, badge: child.badge || item.badge };
      }
    }
    return { title: null, badge: null };
  };

  const pageInfo = getCurrentPageInfo();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar/Drawer */}
      {isMobile ? (
        <Drawer
          open={isOpen}
          onClose={closeSidebar}
          direction="left"
          className="bg-white shadow-lg"
          style={{ width: "16rem" }}
        >
          <Sidebar
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
            isOpen={true} // Always open inside drawer
            isMobile={isMobile}
            onClose={closeSidebar}
            menuItems={UserNavData}
          />
        </Drawer>
      ) : (
        <div
          className={`fixed inset-y-0 left-0 z-30 transition-all duration-300 ease-in-out ${isOpen ? "w-72" : "w-16"
            }`}
        >
          <Sidebar
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
            isOpen={isOpen}
            isMobile={isMobile}
            onClose={closeSidebar}
            menuItems={UserNavData}
          />
        </div>
      )}

      {/* Main Content Area */}
      <div
        className={`
          flex flex-col min-h-screen transition-all duration-300 ease-in-out
          ${isMobile ? "ml-0" : isOpen ? "ml-72" : "ml-16"}
        `}
      >
        {/* Top Bar */}


        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="container m-4 bg-white rounded-2xl">
            {/* Welcome Modal after login */}
            {showWelcomeModal && (
              <CongratulationsModal onClose={handleCloseWelcomeModal} />
            )}
            <TopBar
              userName={user?.name || user?.email || "User"}
              onToggleSidebar={toggleSidebar}
              sidebarOpen={isOpen}
              isMobile={isMobile}
              currentPageTitle={pageInfo.title}
              currentPageBadge={pageInfo.badge}
            />
            <div className="container  bg-white rounded-2xl border-b border-gray-200">
            </div>
            <Routes>
              <Route path="/" element={<Overview />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/purchase-history" element={<PurchaseHistory />} />
              <Route path="/support" element={<Support />} />
              <Route path="/developer-tools" element={<DeveloperTools />} />
              <Route path="/translation" element={<Translation />} />
              <Route path="/website-translation" element={<WebsiteTranslation />} />
              <Route path="/upgrade-plan" element={<UpgradePlan />} />
              {/* Speech Studio */}
              <Route path="/speech-studio/text-to-speech" element={<TextToSpeech />} />
              <Route path="/speech-studio/speech-to-text" element={<SpeechToText />} />
              <Route path="/speech-studio/text-to-speech-translation" element={<TextToSpeechTranslation />} />
              <Route path="/speech-studio/speech-to-text-translation" element={<SpeechToTextTranslation />} />
              <Route path="/speech-studio/speech-translations" element={<SpeechTranslations />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export const userRoutes = [
  {
    path: "/user-dashboard/*",
    element: (
      <ProtectedRoute allowedRoles={["user"]}>
        <UserRoutes />
      </ProtectedRoute>
    ),
  },
];